import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../../assets/scss/components/resouces.scss";
import "../../../assets/scss/components/home.scss";
import SearchBtnGroup from "../../../components/CommonCompnents/resourcePage/SearchBtnGroup";
import Article from "../../../components/CommonCompnents/resourcePage/Article";
import Video from "../../../components/CommonCompnents/resourcePage/Video";
import Footer from "../Footer";
import VideoBanner from "../../../components/CommonCompnents/resourcePage/VideoBanner";
import { constants } from "../../Constants/commenFeatures";
import { getResoucesContent } from "../../../services/Faqs&Resourse/resource";
import introVideo from '../../../assets/video/APIrevised2.mp4'

const Resouces = () => {
  const [resouces, setResouces] = useState({
    articles: [],
    videos: [],
  });

  const mp4VideoObj = {
    name: "Introducing Nuvama API Connect",
    description: "Introducing Nuvama API Connect",
    emtDescription: "<p> Introducing Nuvama API Connect </p>",
    resourceId: "mp4-1",
    date: "2024-01-01T00:00:00.000+05:30",
    url: introVideo,
    ishighlighted: true,
    segment: "product",
    tag: ["Intro"],
    type: "mp4",
  };
  const getResoucesRes = (res) => {
    if (res && res.data) {
      const filteredVideos = (res.data.videos || []).filter(
        (video) => video.name !== "Introducing Edelweiss API Connect"
      );
      const updatedVideos = [mp4VideoObj, ...filteredVideos];
      setResouces({
        articles: res.data.articles || [],
        videos: updatedVideos,
      });
    }
  };

  useEffect(() => {
    const body = {
      article: { pageDate: "", pageLimit: constants.Article, tag: [] },
      video: { pageDate: "", pageLimit: constants.Video, tag: [] },
    };
    getResoucesContent(getResoucesRes, body);
  }, []);

  return (
    <div>
      <div className="container">
        <div className="resoucesPage">
          <h2 className="resoucesPage-header">
            Time to take a plunge into resources, Sign up and Get on it!
          </h2>
          <div className="tradingAlgos">
            {resouces &&
              resouces.videos &&
              resouces.videos.map((video) => {
                return video.ishighlighted === true ? (
                  <VideoBanner video={video} />
                ) : null;
              })}

            <div>
              <div className="custom-row articleVideoWrap articalVedio_row">
                <div className="grid_item_1">
                  <div className="article">
                    <div>
                      <h5>Articles</h5>
                    </div>
                    <div className="article_section_wrap">
                      {resouces &&
                        resouces.articles &&
                        resouces.articles.map((article) => {
                          return (
                            <Article
                              key={article.resourceId}
                              article={article}
                            />
                          );
                        })}
                    </div>
                    <div>
                      <button className="text_btn">
                        <Link to="/articles">View All Articles</Link>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="grid_item_2">
                  <div className="article videos">
                    <div>
                      <h5>Videos</h5>
                    </div>
                    <div className="article_section_wrap">
                      <div className="videoWraps">
                        {resouces &&
                          resouces.videos &&
                          resouces.videos.map((video) => {
                            return video.ishighlighted === false ? (
                              <Video key={video.resourceId} video={video} />
                            ) : null;
                          })}
                      </div>
                    </div>
                    <div>
                      <button className="text_btn">
                        <Link to="/videos">View All Videos</Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Resouces;
